import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { TimeplanUnitRecord } from '../entities/records';
import * as selectors from '../entities/TimeplanUnit/selectors';

function mapStateToProps(state, { timeplanUnitId }) {
  return {
    timeplanUnit: selectors.timeplanUnitById(state, timeplanUnitId),
  };
}

export default compose(
  setPropTypes({
    timeplanUnitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    timeplanUnit: PropTypes.instanceOf(TimeplanUnitRecord),
  }),
)(mapStateToProps);
